import styled from 'styled-components'

export const StyledCheckbox = styled.div`
  cursor: pointer;
  display: flex;
  margin-bottom: 2px;
  align-items: center;
  gap: 4px; 

  svg {
    padding: 2px;
    flex-shrink: 0;
  }
`

export const HiddenInput = styled.input`
  display: none;
`
